<div>
  <h1>{{title}}</h1>
</div>
<div style="display: flex; flex-direction: column; justify-content: left; align-items: center; margin-top: 10px">
  <div *ngFor="let item of items" style="text-align: left; width: 100%;">
    {{item}}
  </div>
    <button mat-raised-button (click)="onClose()">Close</button>
</div>
